import {Popup, Position, ToolbarItem} from 'devextreme-react/popup';
import {useEEToolAdapterContext} from "../contexts/eeToolAdapterContext";
import {SelectBox} from "devextreme-react/select-box";
import {NumberBox} from "devextreme-react/number-box";
import {useRef, useState} from "react";

export function BumpPopupControl() {
    const adapterContext = useEEToolAdapterContext()
    const refBumpWidth = useRef<NumberBox>(null);
    const refBumpDepth = useRef<NumberBox>(null);

    const getOKButtonOptions = {
        stylingMode: 'contained',
        text: 'OK',
        onClick: () => {
            adapterContext.handleBump(refBumpWidth.current?.instance.option('value') ?? 0, refBumpDepth.current?.instance.option('value') ?? 0);
        },
    };

    const getCloseButtonOptions = {
        stylingMode: 'contained',
        text: 'Close',
        type: 'normal',
        onClick: () => adapterContext.hidePopupBump()
    };

    if (!adapterContext.popupBumpVisible)
        return <></>;

    return (
        <>
            <Popup
                title='Enter bump width and depth'
                visible={adapterContext.popupBumpVisible}
                width={adapterContext.popupSize.width}
                height={adapterContext.popupSize.height}
                hideOnOutsideClick={true}
                showCloseButton={true}
                onHidden={() => adapterContext.hidePopupBump()}
            >
                <Position at={'left top'} my={'left top'} offset={{
                    x: adapterContext.popupLocation.left,
                    y: adapterContext.popupLocation.top
                }}></Position>
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getOKButtonOptions}
                />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getCloseButtonOptions}
                />
                <div>
                    <div className="dx-field">
                        <NumberBox
                            defaultValue={adapterContext.bumpWidth}
                            width={'100%'}
                            label='Width'
                            labelMode={'outside'}
                            ref={refBumpWidth}
                        />
                    </div>
                    <div className="dx-field">
                        <NumberBox
                            defaultValue={adapterContext.bumpDepth}
                            width={'100%'}
                            label='Depth'
                            labelMode={'outside'}
                            ref={refBumpDepth}
                        />
                    </div>
                </div>
            </Popup>
        </>
    );
}
